import React, { Component } from 'react';
import L from 'leaflet';
import './../../../../node_modules/leaflet/dist/leaflet.css';

import Core from './../../../Core/Core';
import ErrorManager from './../../../Core/ErrorManager';

import Header from './../../Header';
import SearchForm from './../../Search/SearchForm';

import ErrorBoundary from '../ErrorBoundary';

class Geo extends Component
{
    constructor(props)
    {
        super(props);
        this.map = null;
        this.markers = [];
        this.state={
            "clients" : []
        }

        this.col = React.createRef();

        this.handleSearchForm = this.handleSearchForm.bind(this);

    }

    handleSearchForm(value)
    {
        Core.Instance.Request(Core.Address+"Search/Client->name eq *"+value+"* or Client->phone eq *"+value+"* or Client->phone_mobile eq *"+value+"* or Client->email eq *"+value+"*"
        +" or Client->address eq *"+value+"*"
        +" or Client->postal_code eq *"+value+"*"
        +" or Client->city eq *"+value+"*"
        +" or Client->siret eq *"+value+"*"
        +" or Car->code eq *"+value+"*"
        +" or APV->code eq *"+value+"*"
        +" or Car->vin eq *"+value+"*", null, "GET")
        .then((json) => {
            let clients = json;
            this.setState({
                "clients" : clients
            });
        });
    }

    createContainer()
    {
        let container = document.createElement("div");
        container.id = "map";
        container.style.cssText = "height: 580px";
        this.col.current.appendChild(container);
        this.map = L.map('map').setView([46.6676115, -0.1292665], 6);
        L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(this.map);
    }

    componentDidMount()
    {
        this.createContainer();
        document.title = "W-F: Géolocalisation";
    }

    componentWillUpdate()
    {
        if(this.map != null)
        {
            /*this.markers.forEach((m) => {
                this.map.remove(m);
            });*/
            this.map.off();
            this.map.remove();
        }
        while (this.col.current.firstChild) {
            this.col.current.removeChild(this.col.current.firstChild);
        }
        this.markers = [];
    }

    componentDidUpdate()
    {
        this.createContainer();
        if(this.state.clients.length <= 0)
            return;
        let locations = [];
        let location = "";
        let counter = 1;
        let clients = [];
        let already = [];

        
        // Déclaration des ressources
        let icon = L.icon({
            iconUrl: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA%2FPjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik0xMS41MTMsMTIuMzhjLTIuMTE3LDAtMy44MzUtMS43MjktMy44MzUtMy44NjJjMC0yLjEzNSwxLjcxOC0zLjg2MywzLjgzNS0zLjg2M3MzLjgzNSwxLjcyOSwzLjgzNSwzLjg2MyAgQzE1LjM0OCwxMC42NSwxMy42MywxMi4zOCwxMS41MTMsMTIuMzggTTExLjUxMywwQzYuODI1LDAsMy4wMjUsMy44MjcsMy4wMjUsOC41NDljMCw0LjQ2LDMuODQ0LDEwLjIxMyw2LjQxMSwxMy4wMTQgIGMwLjk1OSwxLjA0NSwyLjA3NiwyLjQ1NCwyLjA3NiwyLjQ1NHMxLjItMS40MTcsMi4yMjktMi40OTNDMTYuMzA2LDE4Ljg0LDIwLDEzLjQ1MSwyMCw4LjU0OUMyMCwzLjgyNywxNi4yLDAsMTEuNTEzLDAiLz48L3N2Zz4%3D",
            iconSize:     [48, 48], // size of the icon
            iconAnchor:   [48/2, 48],
            popupAnchor:[0, -48]
        });
        const key = "G8jKQbKb8nUAjyFnkmnVFEAbFvsKyHdG";

        // récupération des adresses et construction de la requete
        this.state.clients.forEach((c) => {
            if(c.address == null || c.address == "")
                return;
            if(c.latitude != null && c.longitude != null)
            {
                already.push(c);
                return;
            }
            counter = (counter+1) % 95;
            location += "&location="+c.address;
            if(counter == 0)
            {
                locations.push(location);
                location = "";
            }
            clients.push(c);
        });
        locations.push(location);
        location = "";

        let request = null;
        if(clients.length <= 0)
            request = Promise.resolve({
                "results" : []
            });
        else 
        {
            request = Promise.all(locations.map((l) => {
                if(l == "")
                    return Promise.resolve(null);
                return Core.Instance.Request("http://www.mapquestapi.com/geocoding/v1/batch?key="+key+l);
            }));
        }
        request.catch((error) => {
            console.error(error);
            ErrorManager.Instance.Error("Un problème est survenu lors de la conversion des adresses en coordonnées GPS. Vous avez peut être atteint le quota pour le moment.");
        });
        request.then(
            (results) => {
                results.forEach((json) => {
                    if(json == null)
                        return;
                    if(json.results == null)
                    {
                        ErrorManager.Instance.Error("Oups... Quelque chose s'est mal passé avec la carte. Veuillez réessayer plus tard ou contacter le développeur.");
                        return;
                    }
                    for(let i = 0; i < json.results.length; i++)
                    {
                        let location = json.results[i].locations[0];
                        clients[i].latitude = location.latLng.lat;
                        clients[i].longitude = location.latLng.lng;
                        let marker = L.marker([location.latLng.lat, location.latLng.lng], { "icon" : icon}).addTo(this.map);
                        marker.bindPopup(clients[i].name+ " "+ clients[i].first_name +"<br>"+clients[i].address);
                        let client = clients[i];
                        marker.on('mouseover', function (e) {
                            marker.openPopup();
                        });
                        marker.on('mouseout', function (e) {
                            marker.closePopup();
                        });
                        marker.on("click", () => {
                            let win = window.open("/client/"+client.id, "_blank");
                            win.focus();
                        });
                        this.markers.push(marker);
                    }
                });
            }
        )
        .then(() => {
            already.forEach((c) => {
                let marker = L.marker([c.latitude, c.longitude], { "icon" : icon}).addTo(this.map);
                marker.bindPopup(c.name+" "+ c.first_name+"<br>"+c.address);
                let client = c;
                marker.on('mouseover', function (e) {
                    marker.openPopup();
                });
                marker.on('mouseout', function (e) {
                    marker.closePopup();
                });
                marker.on("click", () => {
                    let win = window.open("/client/"+client.id, "_blank");
                    win.focus();
                });
                this.markers.push(marker);
            });
        })
        .then(() => {
            return Promise.all(
                clients.map((c) => {
                    return Core.Instance.Request(Core.Address+"Client/"+c.id, c, "PUT")
                })
            );
        })
        .catch(() => {
            ErrorManager.Instance.Error("Oups... Quelque chose s'est mal passé avec la carte. Veuillez réessayer plus tard ou contacter le développeur.");
        });
    }



    render()
    {
        return (
            <ErrorBoundary>
                <Header />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="card m-3 p-3">
                                <div className="card-body">
                                    <h4 className="card-title"> Recherche simple</h4>
                                    <SearchForm onChange={ this.handleSearchForm } />
                                    <div className="mt-3" ref={ this.col }></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );  
    }
}

export default Geo;


// WEBPACK FOOTER //
// ./src/Components/Views/Geo/Geo.js